export var deviceTypes = [
    { label: "Watch - Navigil", value: "watch" },
    { label: "Body Scale - Withings", value: "scale" },
    { label: "Sleep Mat - Withings", value: "sleep" },
    { label: "Data Hub - Withings", value: "withings_hub" },
];
